import { Toaster } from 'react-hot-toast';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './layouts/Layout';
import AddJob from './pages/AddJob';
import Home from './pages/Home';
function App() {
  return (
    <>

<Toaster />
 
    <Routes>

     

      <Route path="/" element={<Layout />}>
        <Route
          path="/"
          element={<Home />}
        />



        <Route path="add-job" element={<AddJob key='add' />} />
        <Route path="add-job/:id" element={<AddJob key='edit' />} />
        <Route path="jobs/Internship" element={<Home />} />
        <Route path="jobs/Fulltime" element={<Home />} />
        <Route path="jobs/Remote" element={<Home />} />
      </Route>
    </Routes>
   

    </>
  );
}

export default App;
